/**
 * Reusable validation functions
 */

import { removePercentageMask, removePriceMask } from './formatters'

export const validateBrazilianCurrency = (value) => {
  if (!value) return 'Preço é obrigatório'
  
  const cleanValue = removePriceMask(value)
  
  if (!cleanValue) return 'Preço é obrigatório'
  
  const numericValue = parseFloat(cleanValue)
  if (isNaN(numericValue)) {
    return 'Formato inválido. Use formato brasileiro'
  }
  
  if (numericValue <= 0) {
    return 'Preço deve ser maior que zero'
  }
  
  return true
}

export const validateUPC = (value) => {
  if (!value) return 'Código de barras é obrigatório'
  
  const cleanValue = value.trim()
  
  const invalidCharsRegex = /[\s@#$%^&*()+=[\]{}|\\:";'<>?,./]/
  if (invalidCharsRegex.test(cleanValue)) {
    return 'Código de barras não pode conter espaços ou caracteres especiais como @, #, etc.'
  }
  
  if (cleanValue.length < 3) {
    return 'Código de barras deve ter pelo menos 3 dígitos'
  }
  
  return true
}

export const validateChaveFCI = (value) => {
  if (!value) return true 
  
  const cleanValue = value.replace(/-/g, '')
  
  if (cleanValue.length > 0 && cleanValue.length !== 32) {
    return 'Chave FCI deve ter 32 caracteres alfanuméricos'
  }
  
  if (!/^[a-zA-Z0-9]*$/.test(cleanValue)) {
    return 'Chave FCI deve conter apenas letras e números'
  }
  
  return true
}

export const validateNCMFormat = (value) => {
  if (!value) return 'Código NCM é obrigatório'
  
  const ncmPattern = /^\d{4}\.\d{2}\.\d{2}$/
  if (!ncmPattern.test(value)) {
    return 'Formato inválido. Use: 0000.00.00'
  }
  
  return true
}

export const validatePositiveNumber = (value, fieldName = 'Campo') => {
  if (value === null || value === undefined || value === '') {
    return `${fieldName} é obrigatório`
  }
  
  const numValue = parseFloat(value)
  if (isNaN(numValue)) {
    return `${fieldName} deve ser um número válido`
  }
  
  if (numValue < 0) {
    return `${fieldName} deve ser maior ou igual a 0`
  }
  
  return true
}

export const validateAliquota = (value, type = 'generic') => {
  if (!value && value !== 0) return 'Campo obrigatório'
  
  const numValue = parseFloat(value)
  if (isNaN(numValue)) return 'Deve ser um número válido'
  
  if (numValue < 0) return 'Valor deve ser positivo'
  
  const limits = {
    ipi: { max: 330, message: 'IPI deve ser no máximo 330%' },
    pis: { max: 10.65, message: 'PIS deve ser no máximo 10,65%' },
    cofins: { max: 10.65, message: 'COFINS deve ser no máximo 10,65%' },
    fcp: { max: 4, message: 'FCP deve ser no máximo 4%' },
    generic: { max: 100, message: 'Alíquota deve ser no máximo 100%' }
  }
  
  const limit = limits[type] || limits.generic
  if (numValue > limit.max) {
    return limit.message
  }
  
  return true
}

export const validateFCPWithMask = (value) => {
  if (!value) return 'Campo obrigatório'
  
  const cleanValue = removePercentageMask(value)
  const numValue = parseFloat(cleanValue)
  
  if (isNaN(numValue)) return 'Formato inválido'
  if (numValue < 0) return 'Valor deve ser positivo'
  if (numValue > 4) return 'FCP deve ser no máximo 4%'
  
  return true
}

export const validateReduction = (value) => {
  if (!value && value !== 0) return 'Campo obrigatório'
  
  const numValue = parseFloat(value)
  if (isNaN(numValue)) return 'Deve ser um número válido'
  
  if (numValue < 0) return 'Valor deve ser positivo'
  if (numValue > 100) return 'Redução não pode ser maior que 100%'
  
  return true
}

export const validateIpiCodEnq = (value) => {
  if (!value) return 'Código de enquadramento é obrigatório'
  
  const codePattern = /^\d{3}$/
  if (!codePattern.test(value)) {
    return 'Código deve ter 3 dígitos (ex: 999)'
  }
  
  return true
}

export const validateRequired = (value, fieldName = 'Campo') => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return `${fieldName} é obrigatório`
  }
  return true
} 